import React, { useRef, useEffect, useCallback, useMemo } from 'react';

interface ObserverProp {
  intersect(): void;
}

export default function AppIntersectionObserver({
  intersect,
}: ObserverProp): JSX.Element {
  const containerRef = useRef(null);

  const callbackFunction: IntersectionObserverCallback = useCallback(
    (entries) => {
      const [entry] = entries;
      if (entry.isIntersecting) {
        intersect();
      }
    },
    [intersect]
  );

  const options = useMemo(
    () => ({
      root: null,
      rootMargin: '0px',
      threshold: 1.0,
    }),
    []
  );

  useEffect(() => {
    const observer = new IntersectionObserver(callbackFunction, options);
    const loaderRef = containerRef.current;
    if (loaderRef) {
      observer.observe(loaderRef);
    }

    return () => {
      if (loaderRef) {
        observer.unobserve(loaderRef);
      }
    };
  }, [callbackFunction, options]);

  return <div ref={containerRef}></div>;
}
